const Fetcher = require('od-modules/utils/fetcher');
const logger = require('od-modules/utils/logger');

const isAutos = () => window.Odigeo.isAutosEnvironment;

const getRootDocument = () => {
    const hostSplit = window.location.host.split('.');
    const hostPaths =
        hostSplit.length === 3 || hostSplit.length === 4
            ? Odigeo.AB.isChangePaymentInstrumentUrl ? ['https://payments.edreamsodigeo.com'] : ['https://payments'].concat(hostSplit.slice(1))
            : [];

    const path = hostPaths.join('.');
    return isAutos() ? `https://${window.location.host}:8043` : path;
};

const generatePaymentInstrument = async(
    paymentData,
    retry = 0
) => {
    try {
        const paymentInstrumentCall = await Fetcher.post(
            `${getRootDocument()}/payment-instrument/v1/pci-scope-credit-cards`,
            paymentData, true
        );
        const response =
            await paymentInstrumentCall.headers({
                'accept': 'application/json, text/javascript, */*; q=0.01',
            }).json();
        if (!response?.uuid) {
            throw new Error('Invalid uuid response from PIT API');
        }
        return response;
    } catch (e) {
        if (retry < 3) {
            return generatePaymentInstrument(paymentData, retry + 1);
        } else {
            logger.error(e, `There was an error on generatePaymentInstrument call with paymentData ${paymentData}`);
            Odigeo.UIElements.showBrokenFlowError();
            throw e;
        }
    }
};

const getNonPciCardInformation = async(paymentInstrumentToken) => {
    const paymentInstrumentCall = await Fetcher.get(
        `${getRootDocument()}/payment-instrument/v1/non-pci-scope-credit-cards/CREDIT_CARD-${paymentInstrumentToken}`
    );
    return await paymentInstrumentCall.headers({
        'accept': 'application/json, text/javascript, */*; q=0.01',
    }).json();
};

const updateCvv = async(
    paymentInstrumentToken,
    cvv
) => {
    const paymentInstrumentCall = await Fetcher.put(
        `${getRootDocument()}/payment-instrument/v1/pci-scope-credit-cards/${paymentInstrumentToken}/cvv`,
        isAutos() ? JSON.stringify({cvv}) : `${cvv}`,
        false
    );
    return paymentInstrumentCall.headers({
        'accept': 'application/json, text/javascript, */*; q=0.01',
    }).json().then((response) => {
        if (response.status !== 204) {
            logger.error(response, `Response from updateCvv call with status ${response.status}`);
        }
        return response;
    }).catch((error) => {
        logger.error(error, `There was an error on updateCvv call with token ${paymentInstrumentToken}`);
        Odigeo.UIElements.showBrokenFlowError();
    });
};

module.exports = {
    updateCvv,
    generatePaymentInstrument,
    getNonPciCardInformation,
};
